import _regeneratorRuntime from "/opt/build/repo/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/opt/build/repo/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/**
 * @class
 * Class for PageIterator
 */


export var PageIterator =
/*#__PURE__*/
function () {
  /**
   * @public
   * @constructor
   * Creates new instance for PageIterator
   * @param {Client} client - The graph client instance
   * @param {PageCollection} pageCollection - The page collection object
   * @param {PageIteratorCallback} callBack - The callback function
   * @returns An instance of a PageIterator
   */
  function PageIterator(client, pageCollection, callback) {
    _classCallCheck(this, PageIterator);

    this.client = client;
    this.collection = pageCollection.value;
    this.nextLink = pageCollection["@odata.nextLink"];
    this.deltaLink = pageCollection["@odata.deltaLink"];
    this.callback = callback;
    this.complete = false;
  }
  /**
   * @private
   * Iterates over a collection by enqueuing entries one by one and kicking the callback with the enqueued entry
   * @returns A boolean indicating the continue flag to process next page
   */


  _createClass(PageIterator, [{
    key: "iterationHelper",
    value: function iterationHelper() {
      if (this.collection === undefined) {
        return false;
      }

      var advance = true;

      while (advance && this.collection.length !== 0) {
        var item = this.collection.shift();
        advance = this.callback(item);
      }

      return advance;
    }
    /**
     * @private
     * @async
     * Helper to make a get request to fetch next page with nextLink url and update the page iterator instance with the returned response
     * @returns A promise that resolves to a response data with next page collection
     */

  }, {
    key: "fetchAndUpdateNextPageData",
    value: function fetchAndUpdateNextPageData() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.client.api(this.nextLink).get();

              case 3:
                response = _context.sent;
                this.collection = response.value;
                this.nextLink = response["@odata.nextLink"];
                this.deltaLink = response["@odata.deltaLink"];
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                throw _context.t0;

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 9]]);
      }));
    }
    /**
     * @public
     * Getter to get the deltaLink in the current response
     * @returns A deltaLink which is being used to make delta requests in future
     */

  }, {
    key: "getDeltaLink",
    value: function getDeltaLink() {
      return this.deltaLink;
    }
    /**
     * @public
     * @async
     * Iterates over the collection and kicks callback for each item on iteration. Fetches next set of data through nextLink and iterates over again
     * This happens until the nextLink is drained out or the user responds with a red flag to continue from callback
     * @returns A Promise that resolves to nothing on completion and throws error incase of any discrepancy.
     */

  }, {
    key: "iterate",
    value: function iterate() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var advance;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                advance = this.iterationHelper();

              case 2:
                if (!advance) {
                  _context2.next = 12;
                  break;
                }

                if (!(this.nextLink !== undefined)) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 6;
                return this.fetchAndUpdateNextPageData();

              case 6:
                advance = this.iterationHelper();
                _context2.next = 10;
                break;

              case 9:
                advance = false;

              case 10:
                _context2.next = 2;
                break;

              case 12:
                if (this.nextLink === undefined && this.collection.length === 0) {
                  this.complete = true;
                }

                _context2.next = 18;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](0);
                throw _context2.t0;

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 15]]);
      }));
    }
    /**
     * @public
     * @async
     * To resume the iteration
     * Note: This internally calls the iterate method, It's just for more readability.
     * @returns A Promise that resolves to nothing on completion and throws error incase of any discrepancy
     */

  }, {
    key: "resume",
    value: function resume() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                return _context3.abrupt("return", this.iterate());

              case 4:
                _context3.prev = 4;
                _context3.t0 = _context3["catch"](0);
                throw _context3.t0;

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 4]]);
      }));
    }
    /**
     * @public
     * To get the completeness status of the iterator
     * @returns Boolean indicating the completeness
     */

  }, {
    key: "isComplete",
    value: function isComplete() {
      return this.complete;
    }
  }]);

  return PageIterator;
}();